import React from "react";
import TodoList from "./TodoList";
import "./App.scss";
const App = () => {
  return <TodoList />;
};

export default App;
